import Avatar from '../../components/common/Avatar';
import { avatarFor } from '../../utils/avatar';
import { fmtDate } from '../../utils/formatters';
import { hoverTitle } from '../../utils/tooltip';

/* One to-do as the dashboard card shows it: the task, then who it's on and when
   it's due. Read-only here — ticking one off happens on the To-Do page. */
export default function TodoRow({ todo }) {
  const owner = todo.owners[0] || null;
  const name = owner?.name || 'Unassigned';
  const av = avatarFor(name, []);
  const others = todo.owners.length - 1;

  return (
    <div className="todo-row">
      <input
        type="checkbox"
        checked={todo.done}
        readOnly
        disabled
        title={hoverTitle('Open Room Parent To-Do to tick this off')}
      />
      <div className="body">
        <div className="t" style={todo.done ? { textDecoration: 'line-through', color: 'var(--muted)' } : undefined}>
          {todo.task}
        </div>
        <div className="meta">
          <Avatar src={owner?.picture} initials={av.initials} color={av.color} size={19} fontSize={8} />
          <b>{name}{others > 0 ? ` +${others}` : ''}</b>
          {todo.due && <span>· Due {fmtDate(todo.due)}</span>}
        </div>
      </div>
    </div>
  );
}
